export const SET_USER = 'setUser';
export const CLEAR_USER = 'clearUser';
